<div class="backdrop" (click)="onClose_click()"></div>
<div class="popup-content">
  <ion-icon class="close-button" name="close-outline" (click)="onClose_click()"></ion-icon>
  <div class="card-header">
    <h5>{{ title }}</h5>
  </div>
  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>

